import React from 'react';
import moment from 'moment-timezone';
import { EmptyCell, Rotation } from './Rotation';
import { getHolidays, getTimeLabel } from '../../utils';
import { DAYS, MONTHS, ROWS } from '../../const';
var HOURS = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23];
var HeaderCell = function (_a) {
    var children = _a.children, variant = _a.variant;
    var baseClass = 'header-cell';
    var variantClass = "header-cell--".concat(variant.replace('-last', ''));
    var border = variant === 'header-last' ? '0px' : 'auto';
    return (React.createElement("div", { className: "".concat(baseClass, " ").concat(variantClass), style: {
            gridRow: "span ".concat(variant === 'time' ? ROWS : '1'),
            borderRight: border,
        } },
        React.createElement("div", { className: variant === 'time' ? 'header-cell--time-content' : '' }, children)));
};
var TimeColumn = function () { return (React.createElement(React.Fragment, null,
    React.createElement(HeaderCell, { variant: "time-header" }, "\u00A0"),
    Array.from({ length: 24 }, function (_, hour) { return (React.createElement(HeaderCell, { variant: "time", key: "time-".concat(hour) }, hour % 2 === 0 ? getTimeLabel(hour) : '')); }))); };
var DayColumn = function (_a) {
    var date = _a.date, rotations = _a.rotations, contacts = _a.contacts, timezone = _a.timezone, disabled = _a.disabled, readOnly = _a.readOnly, country = _a.country, onClick = _a.onClick, permissions = _a.permissions;
    var hasValidTimezone = Boolean(timezone && moment.tz.zone(timezone));
    var selected = hasValidTimezone ? moment.tz(date, timezone) : moment(date);
    var monday = selected.clone().isoWeekday(1);
    var holidays = getHolidays(country, selected.year());
    return (React.createElement(React.Fragment, null, DAYS.map(function (dayName, day) {
        var _a;
        var colDate = monday.clone().add(day, 'day');
        var subTitle = "".concat(MONTHS[colDate.month()], " - ").concat(colDate.date());
        var variant = day === DAYS.length - 1 ? 'header-last' : 'header';
        var holiday = (_a = holidays.filter(function (h) { return h.day === colDate.date()
            && h.month === colDate.month() + 1; })[0]) === null || _a === void 0 ? void 0 : _a.label;
        var dayRotations = rotations.filter(function (oh) { return Math.trunc(oh.from) >= day * 24 && oh.to <= (day + 1) * 24; });
        return (React.createElement(React.Fragment, { key: "".concat(colDate.format('YYYY-MM-DD'), "_").concat(dayName) },
            React.createElement(HeaderCell, { variant: variant },
                React.createElement("div", null,
                    React.createElement("div", null, dayName),
                    React.createElement("div", null,
                        subTitle,
                        ' ',
                        holiday && (React.createElement("span", { style: {
                                display: 'inline-block',
                                fontSize: '10px',
                                fontWeight: 500,
                                padding: '2px 6px',
                                borderRadius: '10px',
                                backgroundColor: '#e3f2fd',
                                color: '#1565c0',
                                marginLeft: '4px',
                                lineHeight: '1.2',
                                whiteSpace: 'nowrap',
                            } }, holiday))))),
            React.createElement("div", { className: "rotation-container", style: {
                    gridRow: 'span 96',
                    padding: 0,
                } },
                dayRotations.map(function (rotation) { return React.createElement(Rotation, { onClick: onClick, rotation: rotation, contacts: contacts, key: rotation.id, disabled: disabled, readOnly: readOnly }); }),
                HOURS.map(function (hour) { return (React.createElement(EmptyCell, { date: date, dayIndex: day * 24 + hour, span: 0, onClick: onClick, key: "dayIndex_".concat(day * 24 + hour), disabled: disabled, timezone: timezone, permissions: permissions })); }))));
    })));
};
export { TimeColumn, DayColumn };
//# sourceMappingURL=Columns.js.map